import { render, staticRenderFns } from "./OFlatpickrWrapper.vue?vue&type=template&id=4a89f5ce&scoped=true&"
import script from "./OFlatpickrWrapper.vue?vue&type=script&lang=js&"
export * from "./OFlatpickrWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a89f5ce",
  null
  
)

export default component.exports